import { css } from 'styled-components';

export const BREAKPOINTS = {
  laptop: 1440,
  laptopSm: 1366,
  tablet: 1024,
  mobile: 640,
};

export const media = {
  laptop: (...args) => css`
    @media (max-width: ${BREAKPOINTS.laptop}px) {
      ${css(...args)}
    }
  `,
  laptopSm: (...args) => css`
    @media (max-width: ${BREAKPOINTS.laptopSm}px) {
      ${css(...args)}
    }
  `,
  tablet: (...args) => css`
    @media (max-width: ${BREAKPOINTS.tablet}px) {
      ${css(...args)}
    }
  `,
  mobile: (...args) => css`
    @media (max-width: ${BREAKPOINTS.mobile}px) {
      ${css(...args)}
    }
  `,
};

// Висота глобального Header (Components/Header.module.js: padding 12+12 і логотип 40 = 64px) — використовується
// для позиціювання corner-кнопки сайдбара та off-canvas drawer.
export const HEADER_HEIGHT = 64;
